<template>
  <GlobalWindow
    :visible.sync="isVisibled"
    :show="true"
    title="复制"
    width="80%"
    @confirm="confirm"
    @close="(selectData = []), (currency = {cropNum: '',crop: '0',is_title: '0',is_notice: '0',is_repeat_submit: '0'}),$emit('guanbi')"
  >
    <div class="top">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-input
            v-model="mpAdvertiserListParams.name"
            placeholder="请输入广告主名称"
            rows="8"
            @input="($event)=>{
              mpAdvertiserListParams.name = handleParams($event)
            }"
          >
            <i
              slot="prefix"
              class="el-input__icon el-icon-search"
            />
          </el-input>
        </el-col>
        <el-button
          type="primary"
          @click="searchMpAdvert"
        >搜索</el-button>
        <el-button
          type="primary"
          @click="resetMpAdvertList"
        >重置</el-button>
        <el-button
          type="primary"
          @click="clearSelect"
        >清空选项</el-button>
      </el-row>
    </div>

    <div class="center-container">
      <div class="center-left">
        <el-table
          v-if="mpAdvertiserList"
          ref="multipleTable"
          v-loading="isLoading"
          :data="mpAdvertiserList"
          :row-key="getRowKeys"
          border
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            :reserve-selection="true"
            width="55"
          />
          <el-table-column
            prop="id"
            label="ID"
            width="80"
          />
          <el-table-column
            prop="account_id"
            label="account_id"
          />
          <el-table-column
            prop="account_name"
            label="广告主名称"
            show-overflow-tooltip
          />
          <el-table-column
            prop="server_name"
            label="服务商"
            show-overflow-tooltip
          />
          <el-table-column label="复制的量">
            <template slot-scope="scope">
              <input

                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"

                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].num"

                class="input"
                type="number"
                min="1"
                max="50"
                placeholder="复制的量"
                @input="judge(selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0],$event)"
              >
            </template>
          </el-table-column>
          <el-table-column width="150" label="文字">
            <template slot-scope="scope">
              <el-input
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].text_arr"

                placeholder="请输入文字"
                @input="($event)=>{
                  selectData.filter((item)=>{
                    return item.id === scope.row.id
                  })[0].text_arr = handleParams($event)
                }"
              />
            </template>
          </el-table-column>
          <!-- <el-table-column label="截止天数">
            <template slot-scope="scope">
              <el-input
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].tianshu"

                placeholder="请输入内容"
              />
            </template>
          </el-table-column>
          <el-table-column label="时间间隔（分）">
            <template slot-scope="scope">
              <input
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].jiange"
                class="input"
                type="number"
                min="30"
                placeholder="请输入内容"

                @blur="judges(selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0],$event)"
              >
            </template>
          </el-table-column> -->
          <el-table-column label="是否裁剪">
            <template slot-scope="scope">
              <el-select
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].crop"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in optionsCrop"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>

          <el-table-column label="是否修改标题">
            <template slot-scope="scope">
              <el-select
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].is_title"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="是否通知">
            <template slot-scope="scope">
              <el-select
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].is_notice"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="是否重复提交">
            <template slot-scope="scope">
              <el-select
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].is_repeat_submit"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div
        v-if="Object.keys(selectData).length !== 0"
        style="display: flex; flex-direction: column; justify-content: space-between;
               overflow: hidden;"
      >
        <div
          class="center-right"
          style="max-height:430px"
        >
          <h3>已选：</h3>
          <table border="1">
            <thead>
              <tr>
                <td class="fowwr">ID</td>
                <td style="width:90px">account_id</td>
                <td style="width:80px">广告主名称</td>
                <td style="width:80px">服务商</td>
                <td style="width:70px">复制的量</td>
                <td style="width:70px">文字</td>
                <!-- <td style="width:70px">截止天数</td>
              <td style="width:70px">时间间隔（分）</td> -->
                <td style="width:70px">是否裁剪</td>
                <td style="width:70px">是否修改标题</td>
                <td style="width:70px">是否通知</td>
                <td style="width:70px">是否重复提交</td>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in selectData"
                :key="item.account_id"
              >
                <td>{{ item.id }}</td>
                <td>{{ item.account_id }}</td>
                <td>{{ item.account_name }}</td>
                <td>{{ item.server_name }}</td>
                <td>{{ item.num }}</td>
                <td>{{ item.text_arr }}</td>
                <!-- <td>{{ item.tianshu }}</td>
              <td>{{ item.jiange }}</td> -->
                <td>{{ selectOption(item.crop) }}</td>
                <td>{{ item.is_title === '1' ? '是':'否' }}</td>
                <td>{{ item.is_notice === '1' ? '是':'否' }}</td>
                <td>{{ item.is_repeat_submit === '1' ? '是':'否' }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="center-right">
          <h3 style="margin-bottom: 4px;">通用改动：此改动会影响全局</h3>
          <table border="1">
            <thead>
              <tr>
                <td style="width:70px">复制的量</td>
                <td style="width:70px">文字</td>
                <td style="width:70px">是否裁剪</td>
                <td style="width:70px">是否修改标题</td>
                <td style="width:70px">是否通知</td>
                <td style="width:70px">是否重复提交</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <el-input v-model="currency.cropNum" placeholder="请输入复制的量" @input="currency.cropNum = $event.replace(/[^\d]/g, ''),handleCurrencyCropNum()" />
                </td>
                <td>
                  <el-input
                    v-model="currency.text_arr"
                    placeholder="请输入文字"
                    @input="currency.text_arr = handleParams($event), selectData.forEach(item => item.text_arr = currency.text_arr)"
                  />
                </td>
                <td>
                  <el-select
                    v-model="currency.crop"
                    placeholder="请选择是否裁剪"
                    @change="selectData.forEach(item => item.crop = $event) "
                    @visible-change="$event === false && selectData.forEach(item => item.crop = currency.crop)"
                  >
                    <el-option
                      v-for="item in optionsCrop"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </td>
                <td>
                  <el-select
                    v-model="currency.is_title"
                    placeholder="请选择是否修改标题"
                    @change="selectData.forEach(item => item.is_title = $event) "
                    @visible-change="$event === false && selectData.forEach(item => item.is_title = currency.is_title)"
                  >
                    <el-option
                      v-for="item in options1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </td>
                <td>
                  <el-select
                    v-model="currency.is_notice"
                    placeholder="请选择是否通知"
                    @change="selectData.forEach(item => item.is_notice = $event) "
                    @visible-change="$event === false && selectData.forEach(item => item.is_notice = currency.is_notice)"
                  >
                    <el-option
                      v-for="item in options1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </td>
                <td>
                  <el-select
                    v-model="currency.is_repeat_submit"
                    placeholder="请选择是否重复提交"
                    @change="selectData.forEach(item => item.is_repeat_submit = $event) "
                    @visible-change="$event === false && selectData.forEach(item => item.is_repeat_submit = currency.is_repeat_submit)"
                  >
                    <el-option
                      v-for="item in options1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </td>
              </tr>
            </tbody>
          </table>

        </div>
      </div>

    </div>

    <Pagination
      :total="total"
      :page.sync="mpAdvertiserListParams.page"
      :limit.sync="mpAdvertiserListParams.page_size"
      :auto-scroll="false"
      @pagination="fetchMpAdvertiserList"
    />
  </GlobalWindow>
</template>

<script>
import GlobalWindow from '@/components/GlobalWindow.vue'
import Pagination from '@/components/Pagination'
import { mpAdvertiserList/*,  copyMpAdvert */ } from '@/api/customer/accountList/copyMpAdvertManage'
export default {
  name: 'CopyMpAdDialog',
  components: {
    GlobalWindow,
    Pagination
  },
  props: {
    campaign_ids: {}
  },
  data() {
    return {
      isVisibled: false,
      isLoading: false,
      total: 0,
      mpAdvertiserListParams: {
        name: null,
        type: 1,
        page: 1,
        page_size: 10
      },
      selectData: [],
      mpAdvertiserList: null,
      copyMpAdvertParams: {
        account_ids: [],
        account_id: null,
        adgroup_id: null,
        campaign_id: null,
        campaign_type: null
      },
      options: [{
        value: '1',
        label: '是'
      }, {
        value: '0',
        label: '否'
      }],
      options1: [{ value: '1', label: '是' }, { value: '0', label: '否' }],
      optionsCrop: [{
        value: '0',
        label: '不裁剪'
      }, {
        value: '1',
        label: '裁剪'
      }, {
        value: '2',
        label: '四宫格'
      }, {
        value: '3',
        label: '模糊化'
      }
      ],
      currency: { // 控制修改通用的
        cropNum: '',
        crop: '0',
        is_title: '0',
        is_notice: '0',
        is_repeat_submit: '0'
      }
    }
  },
  created() {
    window.This = this
  },
  methods: {
    selectOption(crop) {
      for (let i = 0; i < this.optionsCrop.length; i++) {
        if (this.optionsCrop[i].value === crop) {
          return this.optionsCrop[i].label
        }
      }
    },
    getRowKeys(row) {
      return row.id // 每条数据的唯一识别值
    },

    open(rowData) {
      this.fetchMpAdvertiserList()
      this.isVisibled = true
    },

    // 获取广告主列表
    fetchMpAdvertiserList() {
      this.isLoading = true
      mpAdvertiserList(this.mpAdvertiserListParams).then(res => {
        this.mpAdvertiserList = res.data.list
        this.total = res.data.total
        this.isLoading = false
      })
    },
    clearSelect() {
      // this.$refs.multipleTable.clearSelection()
    },

    // 初始化列表数据
    handleSelectionChange(data) {
      const res = []
      const datas = []
      data.forEach(item => {
        res.push(item.account_id)
        const s4 = this.selectData.filter((it) => {
          return it.id === item.id
        })
        datas.push({
          ...item,
          num: s4.length ? s4[0].num : 1, // 复制的量
          text_arr: s4.length ? s4[0].text_arr : null, // 文字
          tianshu: s4.length ? s4[0].num : 1, // 复制的量
          jiange: s4.length ? s4[0].jiange : 0, // 截止天数
          crop: s4.length ? s4[0].crop : '0', // 是否裁剪
          is_title: s4.length ? s4[0].is_title : '0', // 是否修改标题
          is_notice: s4.length ? s4[0].is_notice : '0', // 是否通知
          is_repeat_submit: s4.length ? s4[0].is_repeat_submit : '0' // 是否重复提交
        })
      })
      this.selectData = datas
      this.copyMpAdvertParams.account_ids = res
    },
    // 复制广告
    handleCopyMpAdvert(params) {
      if (this.copyMpAdvertParams.account_ids.length === 0) {
        this.$message({
          message: '请选择广告主',
          type: 'error'
        })
        return
      }
    },
    searchMpAdvert() {
      this.mpAdvertiserListParams.page = 1
      this.fetchMpAdvertiserList()
    },
    resetMpAdvertList() {
      this.mpAdvertiserListParams = {
        name: null,
        type: 1,
        page: 1,
        page_size: 10
      }
      this.fetchMpAdvertiserList()
    },
    confirm() {
      if (this.copyMpAdvertParams.account_ids.length === 0) {
        this.$message({
          message: '请选择广告主',
          type: 'error'
        })
        return
      }

      const arr = []
      for (let i = 0; i < this.selectData.length; i++) {
        arr.push({
          account: this.selectData[i].account_id,
          num: this.selectData[i].num,
          text_arr: this.selectData[i].text_arr, // 文字
          repetition_days: this.selectData[i].tianshu,
          repetition_interval: this.selectData[i].jiange,
          is_crop: this.selectData[i].crop,
          is_title: this.selectData[i].is_title,
          is_notice: this.selectData[i].is_notice,
          is_repeat_submit: this.selectData[i].is_repeat_submit
        })
      }
      this.$emit('quedin', arr, () => {
        this.copyMpAdvertParams.account_ids = null
        this.isVisibled = false
        this.currency = {
          cropNum: '',
          crop: '0',
          is_title: '0',
          is_notice: '0',
          is_repeat_submit: '0'
        }
      })
    },
    judge(item, event) {
      const text = event.target.value
      console.log('event', event)
      if (Number(text) < 1) {
        text === '' ? item.num = 1 : item.num = Math.abs(text)
      } else if (Number(text) > 50) {
        text === '' ? item.num = 1 : item.num = 50
      }
    },
    judges(item, event) {
      const text = event.target.value
      // if (Number(text) < 30) {
      //   item.jiange = 30
      // }
      if (Number(text) < 30 && Number(text) !== 0) {
        item.jiange = 30
      }
    },
    updateDatarw(item) {
      console.log('222')
    },
    handleCurrencyCropNum() {
      if (!this.currency.cropNum) {
        return
      }
      this.selectData.forEach((item) => {
        item.num = this.currency.cropNum
      })
    },
    handleParams(value) {
      const str = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、 ]/img
      // this.mpAdvertiserListParams.name = value.replace(str, ',')
      const temp = value.replace(str, ',')
      const str1 = /(,){1,}/img
      // this.mpAdvertiserListParams.name = this.mpAdvertiserListParams.name.replace(str1, ',')
      const temp1 = temp.replace(str1, ',')
      return temp1
    }
  }
}
</script>

<style lang="less" scoped>
.center-container {
  margin-top: 20px;
  display: flex;
  .center-left {
    width: 70%;
  }
  .center-right {
    margin-left: 50px;
    // width: 500px;
    // max-height: 500px;
    overflow: auto;
    td {
      padding: 4px;
    }
  }

  .input{
    height: 30px;
    width: 69px;
    padding-left: 5px;
    border: 1px solid #bfbfbf;
    border-radius: 5px;
  }
}
 ::v-deep .center-container .center-left{
      width: 55%;
 }
 .fowwr{
  width:50px
 }
</style>
